<div class="the_container">
    @if(!isMobileView){
    <div class="d-flex justify-content-between">
        <span class="details-text">Master search</span>
        <span class="last-date">Last Refreshed Date - {{lastRefreshedDate}}</span>
    </div>
    }@else{
    <span class="last-date">Last Refreshed Date - {{lastRefreshedDate}}</span>
    }
    <!-- <app-dp-tab-menu [showMasterSearch]="showMasterSearch"></app-dp-tab-menu> -->
    <app-dp-tab-menu-v3 [showMasterSearch]="showMasterSearch"></app-dp-tab-menu-v3>

</div>